import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatTableDataSource } from '@angular/material';

import { VisitService } from './visit.service';

@Component({
  selector: 'visits',
  templateUrl: 'visits.component.html',
  styleUrls: ['./visits.component.scss']
})

export class VisitsComponent implements OnInit {
  loading = false;
  displayedColumns = ['date', 'time', 'name', 'provider', 'clinic'];
  tableData = new MatTableDataSource();
  visits = [];
  visitsReq;
  errors = [];
  sortBy;
  sortAsc = true;
  sortParameter;
  page = 1;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private visitService: VisitService
  ) { }

  ngOnInit() {
    this.route.queryParams.forEach((params: Params) => {
      this.sortBy = params.sortBy ? params.sortBy : 'created_date';
      this.sortAsc = params.sortAsc ? (params.sortAsc === 'true') : false;
      this.sortParameter = params.sortParameter ? params.sortParameter : null;
      this.page = params.page ? params.page : 1;
    });

    this.getVisits({
      ordering: (this.sortAsc ? '' : '-') + this.sortBy,
      [this.sortParameter]: this.sortParameter ? ((this.sortAsc ? '' : '-') + this.sortBy) : null,
      page: this.page
    });
  }

  getVisits(query = {}) {
    this.loading = true;

    if (this.visitsReq) { this.visitsReq.unsubscribe(); }

    this.visitsReq = this.visitService.getVisits({
      ...query
    }).subscribe(visits => {
      this.visits = visits;
      this.tableData.data = this.visits;
      this.loading = false;
    }, err => {
      this.errors = err;
      this.loading = false;
    });
  }

  sort(sortKey) {
    if (this.sortBy === sortKey) { this.sortAsc = !this.sortAsc; }
    this.sortBy = sortKey;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        ...this.route.snapshot.queryParams,
        sortBy: this.sortBy,
        sortAsc: this.sortAsc,
        sortParameter: null
      }
    });
    this.loading = true;
    this.getVisits({
      ordering: (this.sortAsc ? '' : '-') + this.sortBy,
      page: this.page
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/visits/visits.component.ts